import { writable } from 'svelte/store'

interface DialogState {
  open: boolean
  /** When the user dropped a file before the dialog opened, pre-load it. */
  prefillFile: File | null
}

const state = writable<DialogState>({ open: false, prefillFile: null })

export const importDialog = state

export function openImportDialog(prefillFile: File | null = null): void {
  state.set({ open: true, prefillFile })
}

export function closeImportDialog(): void {
  state.set({ open: false, prefillFile: null })
}
